import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostArchivierenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostArchivierenCommandService],
  exports: []
})
export class PostArchivierenCommandServiceModule { }
